export const VERSION_INFO = { tag: 'v2.60.0', branch: 'v2.60.0', commit: 'cdbbca690ff811c99494b4ab4ed633b0e19a9bec', date: 'Thu Oct 17 11:59:14 UTC 2024' }
